import React, { useEffect, useRef, useState } from "react";

const BillingFilterDropdown = ({ id, label, icon, value, options, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const selectedOption = options.find((option) => option.value === value) || options[0];

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  return (
    <div className="billing-filter-field" ref={dropdownRef}>
      <label htmlFor={id}>
        <i className={icon} aria-hidden="true"></i>
        {label}
      </label>
      <div className={`billing-filter-select${isOpen ? " is-open" : ""}`}>
        <button
          id={id}
          type="button"
          className="billing-filter-trigger"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((current) => !current)}
        >
          <span>{selectedOption.label}</span>
          <i className="fa-solid fa-chevron-down" aria-hidden="true"></i>
        </button>
        {isOpen && (
          <div className="billing-filter-options" role="listbox" aria-label={label}>
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                role="option"
                aria-selected={option.value === value}
                className={option.value === value ? "is-selected" : ""}
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
              >
                <span>{option.label}</span>
                {option.value === value && (
                  <i className="fa-solid fa-check" aria-hidden="true"></i>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BillingFilterDropdown;
